// Configure your JavaScript bundler
import "@hotwired/turbo"
import "./controllers/public_index"

// Toggle password visibility
window.togglePassword = function() {
	const passwordInput = document.getElementById('password-input');
	const eyeIcon = document.getElementById('eye-icon');
	if (passwordInput.type === 'password') {
		passwordInput.type = 'text';
		eyeIcon.setAttribute('data-lucide', 'eye-off');
	} else {
		passwordInput.type = 'password';
		eyeIcon.setAttribute('data-lucide', 'eye');
	}
	refreshIcons(eyeIcon.parentElement);
}

const refreshIcons = (root = document) => {
	if (!window.lucide || typeof window.lucide.createIcons !== "function") return

	if (root instanceof Element || root instanceof Document) {
		if (!root.querySelectorAll?.("[data-lucide]").length) return
	}

	window.lucide.createIcons()
}

const rehydrateUi = (root = document) => {
	document.dispatchEvent(new CustomEvent("cms:rehydrate", { detail: { root } }))
}

const setupCmsHomeUi = () => {
	rehydrateUi(document)
}

const closeSearch = () => {
	const overlay = document.querySelector(".js-search-overlay")
	overlay?.classList.add("hidden", "opacity-0")
	overlay?.classList.remove("flex")
	overlay?.setAttribute("aria-hidden", "true")
	document.body.style.overflow = ""
}

const getMobileNav = () => document.querySelector(".js-mobile-nav")

const openMobileNav = () => {
	const mobileNav = getMobileNav()
	const mobilePanel = mobileNav?.querySelector(".js-mobile-panel")
	const mobileBackdrop = mobileNav?.querySelector(".js-mobile-backdrop")
	const navToggle = document.querySelector(".js-nav-toggle")
	if (!mobileNav || !mobilePanel || !mobileBackdrop) return
	mobileNav.classList.remove("hidden")
	mobileNav.setAttribute("aria-hidden", "false")
	navToggle?.setAttribute("aria-expanded", "true")
	document.body.style.overflow = "hidden"
	requestAnimationFrame(() => {
		mobileBackdrop.classList.remove("opacity-0")
		mobilePanel.classList.remove("translate-x-full")
	})
}

const closeMobileNav = () => {
	const mobileNav = getMobileNav()
	const mobilePanel = mobileNav?.querySelector(".js-mobile-panel")
	const mobileBackdrop = mobileNav?.querySelector(".js-mobile-backdrop")
	const navToggle = document.querySelector(".js-nav-toggle")
	if (!mobileNav || !mobilePanel || !mobileBackdrop) return
	mobileNav.querySelectorAll(".js-mobile-submenu").forEach((sub) => closeSubmenu(sub))
	mobilePanel.classList.add("translate-x-full")
	mobileBackdrop.classList.add("opacity-0")
	setTimeout(() => {
		mobileNav.classList.add("hidden")
		mobileNav.setAttribute("aria-hidden", "true")
	}, 300)
	navToggle?.setAttribute("aria-expanded", "false")
	document.body.style.overflow = ""
}

const openSubmenu = (name) => {
	const mobileNav = getMobileNav()
	const sub = mobileNav?.querySelector(`.js-mobile-submenu[data-submenu="${name}"]`)
	const panel = sub?.querySelector(".js-mobile-submenu-panel")
	const back = sub?.querySelector(".js-mobile-backdrop")
	if (!sub || !panel) return
	sub.classList.remove("hidden")
	sub.setAttribute("aria-hidden", "false")
	requestAnimationFrame(() => {
		back?.classList.remove("opacity-0")
		panel.classList.remove("translate-x-full")
	})
}

const closeSubmenu = (sub) => {
	const panel = sub.querySelector(".js-mobile-submenu-panel")
	const back = sub.querySelector(".js-mobile-backdrop")
	if (!panel) return
	panel.classList.add("translate-x-full")
	back?.classList.add("opacity-0")
	setTimeout(() => {
		sub.classList.add("hidden")
		sub.setAttribute("aria-hidden", "true")
	}, 300)
}

document.addEventListener("click", (event) => {
	const toggle = event.target.closest(".js-nav-toggle")
	if (toggle) { event.preventDefault(); openMobileNav(); return }

	const close = event.target.closest(".js-mobile-close")
	if (close) { closeMobileNav(); return }

	if (event.target.classList.contains("js-mobile-backdrop") && event.target.closest(".js-mobile-nav")) {
		closeMobileNav(); return
	}

	const trigger = event.target.closest(".js-mobile-submenu-trigger")
	if (trigger) { openSubmenu(trigger.dataset.submenu); return }

	const back = event.target.closest(".js-mobile-submenu-back")
	if (back) {
		const sub = back.closest(".js-mobile-submenu")
		if (sub) closeSubmenu(sub)
		return
	}

	const searchToggle = event.target.closest(".js-search-toggle")
	if (searchToggle) {
		const overlay = document.querySelector(".js-search-overlay")
		if (overlay) {
			overlay.classList.remove("hidden", "opacity-0")
			overlay.classList.add("flex")
			requestAnimationFrame(() => overlay.classList.remove("opacity-0"))
			overlay.setAttribute("aria-hidden", "false")
			document.body.style.overflow = "hidden"
		}
		return
	}

	const searchClose = event.target.closest(".js-search-close")
	if (searchClose) { closeSearch(); return }

	if (event.target.classList.contains("js-search-overlay")) { closeSearch(); return }
})

document.addEventListener("keydown", (event) => {
	if (event.key === "Escape") {
		const overlay = document.querySelector(".js-search-overlay")
		if (overlay?.getAttribute("aria-hidden") === "false") closeSearch()
	}
})

document.addEventListener("turbo:load", setupCmsHomeUi)
document.addEventListener("cms:rehydrate", (event) => refreshIcons(event.detail?.root || document))
document.addEventListener("turbo:render", () => rehydrateUi(document))
document.addEventListener("turbo:frame-load", (event) => rehydrateUi(event.target || document))
document.addEventListener("turbo:before-stream-render", (event) => {
	const originalRender = event.detail.render
	event.detail.render = (streamElement) => {
		originalRender(streamElement)
		const targetRoot = streamElement?.target ? document.getElementById(streamElement.target) || document : document
		requestAnimationFrame(() => rehydrateUi(targetRoot))
	}
})
